<template>
  <div class="infor fl">
    <all-header
      :label="lable"
      :ischage="ischage"
      :sublabel="sublabel"
      :subtitle="subtitle"
      @getvalue="goBack"></all-header>

    <div class="download-box">
      <div class="row">
        <div class="label">证书类型</div>
        <div class="value">
          <el-radio-group v-if="certificateTypes.length" v-model="selectedTypeId" class="type-group">
            <el-radio
              v-for="item in certificateTypes"
              :key="item.id"
              :label="item.id"
              border
              class="type-item"
            >{{ item.name }}</el-radio>
          </el-radio-group>
          <span v-else>—</span>
        </div>
      </div>

      <div class="row">
        <div class="label">用户手机号</div>
        <div class="value">
          <el-input v-model="phone" placeholder="请输入" maxlength="11" />
        </div>
      </div>

      <div class="row">
        <div class="label">验证码</div>
        <div class="value code-row">
          <el-input v-model="smsCode" placeholder="请输入" maxlength="6" />
          <el-button
            class="code-btn"
            :disabled="smsCountdown > 0"
            @click="sendSms"
          >{{ smsCountdown > 0 ? `${smsCountdown}s后重试` : '获取验证码' }}</el-button>
        </div>
      </div>

      <div class="btn-row">
        <el-button type="primary" class="btn-download" :loading="downloading" @click="onDownload">
          获取证书
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { SendDownloadSms, CertificateDetail, CertificateTypes } from '../utils/api.js';
import AllHeader from './Modal/AllHeader.vue';

export default {
  name: 'CertificatesDownload',
  components: {
    AllHeader,
  },
  data() {
    return {
      certificateTypes: [],
      selectedTypeId: null,
      phone: '',
      smsCode: '',
      smsCountdown: 0,
      smsTimer: null,
      downloading: false,
      sublabel: '返回记录列表',
      subtitle: '',
      ischage: true,
      lable: '',
    };
  },
  mounted() {
    this.lable = this.$route.query.name || '荣誉证书';
    this.subtitle = this.$route.query.award_title || '';
    this.loadCertificateType();
    this.loadCertificateTypes();
  },
  beforeDestroy() {
    clearInterval(this.smsTimer);
  },
  methods: {
    getCertId() {
      const q = this.$route.query || {};
      return (
        q.cert_id ||
        q.certId ||
        q.id ||
        q['cert id'] ||
        q.certid ||
        null
      );
    },
    goBack() {
      const awardId = this.$route.query.award_id;
      const awardTitle = this.$route.query.award_title;
      this.$router.push({
        path: '/member/certificates/list',
        query: {
          award_id: awardId,
          award_title: awardTitle,
          name: '荣誉证书明细',
        },
      });
    },
    loadCertificateType() {
      const certId = this.getCertId();
      if (!certId) return;
      CertificateDetail(certId).then((res) => {
        const cert = res.data || res;
        this.selectedTypeId =
          cert?.certificate_type_id ||
          cert?.certificateType?.id ||
          cert?.certificate_type?.id ||
          this.selectedTypeId;
      }).catch(() => {
        this.selectedTypeId = this.selectedTypeId;
      });
    },
    loadCertificateTypes() {
      const awardId = this.$route.query.award_id;
      CertificateTypes(awardId).then((res) => {
        const list = res.data || res || [];
        this.certificateTypes = Array.isArray(list) ? list : [];
        if (!this.selectedTypeId && this.certificateTypes.length) {
          this.selectedTypeId = this.certificateTypes[0].id;
        }
      }).catch(() => {
        this.certificateTypes = [];
      });
    },
    sendSms() {
      if (!this.phone || this.phone.length !== 11) {
        this.$message.warning('请输入正确的手机号');
        return;
      }
      const certId = this.getCertId();
      if (!certId) {
        this.$message.error('证书信息缺失');
        return;
      }
      SendDownloadSms(this.phone, certId)
        .then(() => {
          this.$message.success('验证码已发送');
          this.smsCountdown = 60;
          this.smsTimer = setInterval(() => {
            this.smsCountdown--;
            if (this.smsCountdown <= 0) clearInterval(this.smsTimer);
          }, 1000);
        })
        .catch(err => {
          this.$message.error(err || '发送失败');
        });
    },
    async onDownload() {
      const certId = this.getCertId();
      if (!certId) {
        this.$message.error('证书信息缺失');
        return;
      }
      if (!this.phone || !this.smsCode) {
        this.$message.warning('请填写手机号和验证码');
        return;
      }
      this.downloading = true;
      try {
        const baseURL = process.env.NODE_ENV === 'development' ? 'https://test-dev.welamp.cn/api/home' : '/api/home';
        const url = `${baseURL}/certificate/download/${certId}`;
        const token = localStorage.getItem('TOKEN');
        const res = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          body: JSON.stringify({
            phone: this.phone,
            sms_code: this.smsCode,
          }),
        });

        const contentType = (res.headers.get('content-type') || '').toLowerCase();
        if (!res.ok || contentType.includes('application/json')) {
          let message = '下载失败，请检查验证码';
          try {
            const data = await res.json();
            message = data?.message || message;
          } catch (e) {
            // ignore json parse error
          }
          this.$message.error(message);
          return;
        }

        const blob = await res.blob();
        const disposition = res.headers.get('content-disposition') || '';
        let filename = `certificate_${certId}.pdf`;
        const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
        const asciiMatch = disposition.match(/filename="?([^\";]+)"?/i);
        if (utf8Match && utf8Match[1]) {
          filename = decodeURIComponent(utf8Match[1]);
        } else if (asciiMatch && asciiMatch[1]) {
          filename = asciiMatch[1];
        }

        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      } catch (err) {
        this.$message.error(err || '下载失败，请检查验证码');
      } finally {
        this.downloading = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.infor-t-r {
  padding: 6px 14px;
  border: 1px solid #5d8dff;
  color: #5d8dff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  line-height: 18px;
}

.download-box {
  width: 720px;
  margin: 24px auto 0;
  padding: 22px 36px 26px;
  background: #fff;
  border: 1px solid #e6ebf2;
  border-radius: 4px;
}

.row {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.label {
  width: 120px;
  color: #606266;
  font-size: 14px;
  text-align: right;
  padding-right: 16px;
}

.value {
  flex: 1;
}

.code-row {
  display: flex;
  gap: 12px;
  align-items: center;
}

.code-btn {
  width: 110px;
}

.btn-row {
  display: flex;
  justify-content: center;
  margin-top: 18px;
}

.btn-download {
  width: 140px;
}
.type-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.type-item {
  margin: 0;
}
</style>
